export default __webpack_public_path__ + "static/media/tekstihindaja.c30e72b6.png";